import {Button, FlipList, Loading, setNotification} from '@startlibs/components';
import {formatDate, getColor, stopPropagation} from '@startlibs/utils';
import React, {useEffect} from 'react'
import styled from 'styled-components/macro';

import {
  PanelButton,
  WidgetBody,
  WidgetFooter,
  WidgetHeader,
  WidgetPanelComponent
} from './PanelStyles';
import {RecordItem} from './RecordItem'
import {UploaderAction} from '../lib/service'
import {touchClick} from './utils'
import {usePanelUtils} from './usePanelUtils'
import {RecordStatus} from '../lib/utils/recordEnums'
import {useUploadLog} from '../lib/service/uploadLog'
import {getDate} from '../../utils/utils'

const IgnoredFilesWarning = styled.div`
  padding: 1rem;
  background: ${getColor('gray240')};
  border-radius: 6px;
  margin-bottom: 0.75rem;
  font-weight: bold;
  font-size: 13px;
  .link {
    font-size: 12px;
    margin-left: 0.25rem;
  }
`

export const UploadPanel = ({records, openUploadDialog,data,doAction, hidden, uploadLogDialog, setUploadPanelOn}) => {

  const [{refs}, maximized, toggleMaximized, isRefocusingPanel, isHighlighting] = usePanelUtils()
  const panelRef = refs.panel
  const scrollContainerRef = refs.scrollContainer

  const isUploading = records.find(({fileProgress}) => fileProgress.total - fileProgress.uploaded - fileProgress.failed)
  const isProcessing = data.isProcessing > 0
  const hasFailed = records.find(({status}) => status === RecordStatus.Failed)

  useEffect(() => {
    data.activated && toggleMaximized(true)
  },[data.activated])

  useEffect(() => {
    !records.length && maximized && toggleMaximized(false)
  },[records.length])

  useEffect(() => {
    if (!maximized && !records.length) {
      setTimeout(() => doAction(UploaderAction.Deactivate,data.activated),300)
    }
    if(maximized){
      setUploadPanelOn(2)
    }else{
      setUploadPanelOn(1)
    }
  },[maximized])

  useEffect(() =>  () => {
    if (isUploading) {
      setNotification("All uploads have finished")
    }
  },[!isUploading])

  if (!data.activated || hidden) {
    setUploadPanelOn(false)
    return null
  }
  // setUploadPanelOn(true)

  const todayDate = formatDate(getDate(0), "yyyy-MM-dd",null, true)

  return <WidgetPanelComponent id="upload-panel"
    className="JS-fix-dialog-scroll" maximized={maximized}
    ref={panelRef}
  >
    <WidgetHeader onClick={toggleMaximized} onTouchStart={touchClick(toggleMaximized)}>
      {(isUploading || isProcessing) && <Loading white/>}
      <div css="margin-right:auto;">
        {
          isProcessing 
            ? <h4>Processing... </h4> 
            : isUploading
              ? <h4>Uploading studies</h4>
              : <h4>All studies uploaded</h4>
        }
        {maximized && <a onClick={stopPropagation(uploadLogDialog.open)}>Upload log</a>}
      </div>
      {maximized && <>
        <PanelButton icon="expand" onClick={openUploadDialog}/>
        <PanelButton icon="arrow-down-line"/>
      </>
      }
    </WidgetHeader>
    <WidgetBody ref={scrollContainerRef}>
      {
        data.discarded?.length > 0 && <IgnoredFilesWarning>
          {data.discarded.length} file{data.discarded.length > 1 && 's'}  ignored <a className="link" onClick={uploadLogDialog.open}>Details</a>
        </IgnoredFilesWarning>
      }
        <FlipList>{records.map(record => <RecordItem key={record.key} openLog={() => {
          uploadLogDialog.openWith({filter:(allFiles) => {
            const recordFiles =  doAction(UploaderAction.GetFilesForRecord,record.key)
            return allFiles.filter(({file}) => recordFiles.includes(file))
          }})
        }} doAction={doAction} record={record}/>)}</FlipList>
    </WidgetBody>
    <WidgetFooter>
      <Button.Link css="width:100%;" outline highlight to={`?page=1&uploadDateInit=${todayDate}&uploadDateEnd=${todayDate}`}>
        Show studies added recently
      </Button.Link>
    </WidgetFooter>
  </WidgetPanelComponent>
}